/* OMINA 4.0 — comportements ajoutés par cette version.
   Trois modules indépendants, sans dépendance externe :
     V4-12  bouton son de la vidéo de démonstration
     V4-10  pop-up promotionnelle
     V4-19  validation réelle du formulaire Moment OMINA

   Règles communes : garde contre la double initialisation dans l'éditeur
   Shopify, réécoute sur shopify:section:load, aucun console.log, aucun blocage
   si le stockage est indisponible, respect de prefers-reduced-motion. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------------------------------------------------------------
     Stockage tolérant : en navigation privée ou stockage bloqué, on
     n'échoue jamais — la pop-up se comporte alors comme « une fois par page ».
     --------------------------------------------------------------------- */
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* ignoré */ } }
  };

  /* ===================== V4-12 — Bouton son vidéo ===================== */
  function initVideoSound(scope) {
    (scope || document).querySelectorAll('[data-omina-video][data-sound-button]').forEach(function (host) {
      if (host.dataset.ominaSoundReady === 'true') return;
      var video = host.querySelector('video');
      if (!video) return;                    // vidéo Shopify en iframe : pas de contrôle son
      host.dataset.ominaSoundReady = 'true';

      // L'autoplay impose le mode muet : le son ne peut être activé que par
      // une action explicite du visiteur.
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'omina-video-sound';
      button.setAttribute('data-position', host.dataset.soundPosition || 'top_right');

      function paint() {
        var muted = video.muted;
        button.setAttribute('aria-pressed', muted ? 'false' : 'true');
        button.setAttribute('aria-label', muted ? 'Activer le son de la vidéo' : 'Couper le son de la vidéo');
        button.innerHTML = muted
          ? '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M11 5.5 7 9H3.5v6H7l4 3.5v-13Z"/><path d="m16 9.5 4 5M20 9.5l-4 5"/></svg>'
          : '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M11 5.5 7 9H3.5v6H7l4 3.5v-13Z"/><path d="M15.5 9.5c1 1.4 1 3.6 0 5"/><path d="M18 7.5c1.9 2.5 1.9 6.5 0 9"/></svg>';
      }

      button.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted && video.paused) video.play().catch(function () {});
        paint();
      });

      paint();
      host.appendChild(button);

      // Mouvement réduit : on ne démarre jamais automatiquement.
      if (reduceMotion.matches) {
        video.autoplay = false;
        video.pause();
        return;
      }

      // Lecture automatique fiable. L'attribut `autoplay` seul ne suffit pas :
      // plusieurs navigateurs l'ignorent quand la vidéo n'est pas encore
      // visible, ou quand `preload` a différé le chargement. On force donc le
      // mode muet — condition de toute lecture automatique — puis on appelle
      // `play()` dès que la vidéo entre dans l'écran. Si le navigateur refuse
      // malgré tout, les contrôles restent disponibles : rien n'est bloqué.
      if (host.hasAttribute('data-autoplay')) {
        video.muted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;

        var demarrer = function () {
          var essai = video.play();
          if (essai && essai.catch) essai.catch(function () { /* refus du navigateur : on n'insiste pas */ });
        };

        if ('IntersectionObserver' in window) {
          var vigie = new IntersectionObserver(function (entrees) {
            entrees.forEach(function (e) {
              if (e.isIntersecting) demarrer();
              else if (!video.paused) video.pause();
            });
          }, { threshold: 0.25 });
          vigie.observe(video);
        } else {
          demarrer();
        }
      }
    });
  }

  /* ===================== V4-10 — Pop-up promotionnelle ===================== */
  function initPromo(scope) {
    var promo = (scope || document).querySelector('[data-omina-promo]');
    if (!promo || promo.dataset.ominaPromoReady === 'true') return;
    promo.dataset.ominaPromoReady = 'true';

    var dialog = promo.querySelector('.omina-promo__dialog');
    var frequency = promo.dataset.frequency || 'session';
    var delay = parseInt(promo.dataset.delay, 10) || 0;
    var key = 'omina_promo_' + (promo.dataset.version || '1');
    var lastFocused = null;
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    function seen() {
      if (inEditor) return false;            // l'éditeur doit toujours pouvoir prévisualiser
      var v = store.get(key);
      if (!v) return false;
      if (frequency === 'session') return true;
      var days = frequency === 'days7' ? 7 : 30;
      return (Date.now() - Number(v)) < days * 86400000;
    }

    function mark() {
      if (inEditor) return;
      store.set(key, frequency === 'session' ? 'seen' : String(Date.now()));
    }

    function focusables() {
      return Array.prototype.slice
        .call(dialog.querySelectorAll('button, [href], input, select, textarea'))
        .filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocused = document.activeElement;
      promo.hidden = false;
      // Verrou de fond sans décalage de page : la barre reste réservée.
      var sw = window.innerWidth - document.documentElement.clientWidth;
      if (sw > 0) document.body.style.paddingRight = sw + 'px';
      document.body.classList.add('omina-promo-open');
      document.addEventListener('keydown', onKeydown);
      var list = focusables();
      if (list.length) list[0].focus();
      mark();
    }

    function close() {
      promo.hidden = true;
      document.body.classList.remove('omina-promo-open');
      document.body.style.paddingRight = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    promo.querySelectorAll('[data-omina-promo-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Copie du code de réduction
    var copy = promo.querySelector('[data-omina-promo-copy]');
    if (copy && navigator.clipboard) {
      copy.addEventListener('click', function () {
        navigator.clipboard.writeText(copy.dataset.code || '').then(function () {
          var before = copy.textContent;
          copy.textContent = 'Copié';
          setTimeout(function () { copy.textContent = before; }, 1800);
        }).catch(function () {});
      });
    } else if (copy) {
      copy.hidden = true;                    // pas d'API : on n'affiche pas un bouton inerte
    }

    if (seen()) return;
    if (inEditor) { open(); return; }
    window.setTimeout(open, delay);
  }

  /* ===================== V4-19 — Validation du formulaire ===================== */
  function initMomentForm(scope) {
    var form = (scope || document).querySelector('#OminaMomentForm');
    if (!form || form.dataset.ominaValidateReady === 'true') return;
    form.dataset.ominaValidateReady = 'true';

    // Amélioration progressive. Les attributs `required` restent dans le HTML :
    // sans JavaScript, le navigateur bloque donc lui-même l'envoi. Avec
    // JavaScript, on désactive la validation native — sinon elle court-circuite
    // l'événement `submit`, et le résumé d'erreurs accessible, les messages qui
    // nomment le champ, `aria-invalid` et `aria-describedby` ne s'affichent
    // jamais. Les deux consentements restent obligatoires ; l'autorisation de
    // republication reste facultative.
    form.noValidate = true;

    var summary = form.querySelector('[data-omina-form-errors]');

    function labelOf(field) {
      var lbl = form.querySelector('label[for="' + field.id + '"]');
      return lbl ? lbl.textContent.trim().replace(/\s*\*$/, '') : 'ce champ';
    }

    function messageFor(field) {
      if (field.type === 'checkbox') return 'Coche « ' + labelOf(field) +' » pour continuer.';
      if (field.validity.valueMissing) return 'Renseigne ' + labelOf(field).toLowerCase() + '.';
      if (field.type === 'email') return 'Vérifie ton adresse e-mail : elle semble incomplète.';
      if (field.type === 'url') return 'Le lien doit être une adresse complète, commençant par https://';
      return 'Vérifie ' + labelOf(field).toLowerCase() + '.';
    }

    function clearField(field) {
      field.removeAttribute('aria-invalid');
      var id = field.id + '-error';
      var msg = document.getElementById(id);
      if (msg) msg.remove();
      var describedBy = (field.getAttribute('aria-describedby') || '')
        .split(' ').filter(function (x) { return x && x !== id; }).join(' ');
      if (describedBy) field.setAttribute('aria-describedby', describedBy);
      else field.removeAttribute('aria-describedby');
    }

    function markField(field, text) {
      field.setAttribute('aria-invalid', 'true');
      var id = field.id + '-error';
      if (!document.getElementById(id)) {
        var p = document.createElement('p');
        p.id = id;
        p.className = 'omina-form__field-error';
        p.textContent = text;
        (field.closest('.omina-form__field') || field.parentNode).appendChild(p);
      }
      var describedBy = field.getAttribute('aria-describedby');
      field.setAttribute('aria-describedby', describedBy ? describedBy + ' ' + id : id);
    }

    form.addEventListener('submit', function (event) {
      var invalid = [];
      form.querySelectorAll('input, textarea, select').forEach(function (field) {
        if (!field.willValidate) return;
        clearField(field);
        if (!field.checkValidity()) invalid.push(field);
      });

      if (invalid.length) {
        // C'est le correctif : la soumission est réellement bloquée.
        event.preventDefault();

        invalid.forEach(function (field) { markField(field, messageFor(field)); });

        if (summary) {
          summary.innerHTML = '<p class="omina-form__errors-title">Ton envoi n\'a pas pu être pris en compte :</p>';
          var ul = document.createElement('ul');
          invalid.forEach(function (field) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = '#' + field.id;
            a.textContent = messageFor(field);
            a.addEventListener('click', function (e) { e.preventDefault(); field.focus(); });
            li.appendChild(a);
            ul.appendChild(li);
          });
          summary.appendChild(ul);
          summary.hidden = false;
          summary.setAttribute('tabindex', '-1');
          summary.focus();
        } else {
          invalid[0].focus();
        }
        return;
      }

      if (summary) { summary.hidden = true; summary.innerHTML = ''; }

      if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
      form.dataset.submitting = 'true';
    });

    // L'erreur disparaît dès que le visiteur corrige.
    form.addEventListener('input', function (e) {
      if (e.target.willValidate && e.target.checkValidity()) clearField(e.target);
    });
    form.addEventListener('change', function (e) {
      if (e.target.willValidate && e.target.checkValidity()) clearField(e.target);
    });
  }

  /* ===================== V4-06b — Flèches de la galerie produit ===================== */
  /* Sur mobile, `slider-component` fait déjà défiler le carrousel horizontal :
     on le laisse entièrement maître. Sur desktop, en disposition « vignettes »,
     la liste n'est plus un carrousel — un seul média est affiché à la fois — et
     les boutons de Dawn n'ont donc plus d'effet. On reprend la main pour appeler
     `setActiveMedia`, qui met à jour la vignette, la région live et l'état actif
     sans jamais faire défiler la page verticalement (cf. media-gallery.js). */
  function initGalleryArrows(scope) {
    (scope || document).querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.ominaArrowsReady === 'true') return;

      var viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer) return;
      var arrows = viewer.querySelector('.omina-gallery-arrows');
      if (!arrows) return;                       // un seul média : rien n'est rendu
      var prev = arrows.querySelector('button[name="previous"]');
      var next = arrows.querySelector('button[name="next"]');
      var counter = arrows.querySelector('.slider-counter--current');
      if (!prev || !next) return;

      gallery.dataset.ominaArrowsReady = 'true';
      var desktop = window.matchMedia('(min-width: 750px)');

      function takeOver() {
        var layout = gallery.dataset.desktopLayout || '';
        return desktop.matches && layout.indexOf('thumbnail') !== -1;
      }

      // Cibler `.product__media-item` et non `[data-media-id]` : cet attribut est
      // aussi porté par les éléments internes (product-model, deferred-media).
      // La liste comptait donc deux entrées par média, et un pas sur deux
      // tombait sur un nœud interne — d'où une image affichée sur deux.
      function items() {
        return Array.prototype.slice.call(viewer.querySelectorAll('.product__media-item[data-media-id]'));
      }

      function index(list) {
        var active = viewer.querySelector('.product__media-item[data-media-id].is-active');
        var i = list.indexOf(active);
        return i < 0 ? 0 : i;
      }

      function paint() {
        if (!takeOver()) return;
        var list = items();
        var i = index(list);
        // Pas de navigation circulaire : elle ne serait pas testable ici, donc
        // on désactive proprement aux extrémités (cahier §10.2).
        prev.disabled = i <= 0;
        next.disabled = i >= list.length - 1;
        if (counter) counter.textContent = String(i + 1);
      }

      function go(step) {
        var list = items();
        var target = list[index(list) + step];
        if (!target || typeof gallery.setActiveMedia !== 'function') return;
        gallery.setActiveMedia(target.dataset.mediaId, false);
        paint();
      }

      // Écoute en phase de capture sur le conteneur : elle précède le gestionnaire
      // que slider-component a posé sur les boutons eux-mêmes, et l'arrêt de la
      // propagation évite qu'un défilement horizontal inutile soit déclenché.
      arrows.addEventListener(
        'click',
        function (event) {
          var button = event.target.closest ? event.target.closest('.slider-button') : null;
          if (!button || !takeOver()) return;
          event.preventDefault();
          event.stopPropagation();
          go(button.name === 'next' ? 1 : -1);
        },
        true
      );

      // Le média actif change aussi via les vignettes ou un changement de variante.
      new MutationObserver(paint).observe(viewer, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });

      function onBreakpoint() {
        if (takeOver()) {
          paint();
        } else {
          // Retour au mobile : slider-component reprend la main sur ces états.
          prev.disabled = false;
          next.disabled = false;
        }
      }

      if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
      else if (desktop.addListener) desktop.addListener(onBreakpoint);

      paint();
    });
  }

  function init(scope) {
    initVideoSound(scope);
    initPromo(scope);
    initMomentForm(scope);
    initGalleryArrows(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
